<template>
  <ReportedBugs v-if="isAdmin" ref="fileTable" />
</template>

<script>
import ReportedBugs from "@/components/Dashboard/Views/ReportedBugs/ReportedBugs.vue";
import store from "@/store/store";
export default {
  components: {
    ReportedBugs,
  },
  computed: {
    isAdmin() {
      const user = store.state.auth.user;
      return user && user.role === "admin";
    }
  },
  mounted() {
    if (!this.isAdmin) {
      this.$router.push("/overview");
    }
  },
  methods: {
    refreshFiles() {
      this.$refs.fileTable && this.$refs.fileTable.$forceUpdate();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ReportedBugs/index.vue